export default "__VITE_ASSET__w3RmL17w__"